import axios from '@/utils/request';

function ADD(params) {
    return axios.get("/kshadmin/PanelRole/create", {
        params: params
    })
}

function ADD_POST(params) {
    return axios.post("/kshadmin/PanelRole/createPost", {
        ...params
    })
}

function EDIT(params) {
    return axios.get("/kshadmin/PanelRole/edit", {
        params: params
    })
}

function EDIT_POST(params) {
    return axios.post("/kshadmin/PanelRole/editPost", {
        ...params
    })
}

export default {
    ADD,
    ADD_POST,
    EDIT,
    EDIT_POST
};